module.exports = __webpack_public_path__ + "static/media/glass.58b8dd3d.svg";